import {AppAction} from '../appActions';
import {ElectronActionTypesEnum} from './electronActions';
import {ElectronState} from './electronState';

/*
 * Reducer.
 */

export function electronReducer(state: ElectronState | null = null, action: AppAction): ElectronState | null {
  switch (action.type) {
    case ElectronActionTypesEnum.INITIALIZED: {
      return action.payload;
    }

    case ElectronActionTypesEnum.DID_OPEN_APPLICATION_MENU: {
      if (!state) {
        return null;
      }

      return {
        ...state,
        isApplicationMenuOpen: true,
      };
    }

    case ElectronActionTypesEnum.DID_CLOSE_APPLICATION_MENU: {
      if (!state) {
        return null;
      }

      return {
        ...state,
        isApplicationMenuOpen: false,
      };
    }

    case ElectronActionTypesEnum.DID_MAXIMIZE: {
      if (!state) {
        return null;
      }

      return {
        ...state,
        isMaximized: true,
      };
    }

    case ElectronActionTypesEnum.DID_UNMAXIMIZE: {
      if (!state) {
        return null;
      }

      return {
        ...state,
        isMaximized: false,
      };
    }

    case ElectronActionTypesEnum.DID_ENTER_FULL_SCREEN: {
      if (!state) {
        return null;
      }

      return {
        ...state,
        isFullScreen: true,
      };
    }

    case ElectronActionTypesEnum.DID_LEAVE_FULL_SCREEN: {
      if (!state) {
        return null;
      }

      return {
        ...state,
        isFullScreen: false,
      };
    }

    case ElectronActionTypesEnum.ZOOM_FACTOR_UPDATED: {
      if (!state) {
        return null;
      }

      const {zoomFactor} = action.payload;
      return {
        ...state,
        zoomFactor,
      };
    }

    default: {
      return state;
    }
  }
}
